import AWS from "aws-sdk";
import store from "@/store";
import axios from "axios";
import AuthService, { ICredentialsResponse } from "./auth.service";

// interface ISBAuthSuccessResponse {
//   status: string;
//   message: string;
//   contract: {
//     contract_id: string;
//     servicegroup_id: string;
//   };
// }

// interface ISBAuthFailedResponse {
//   status: string;
//   message: string;
// }

export default class StarBridgeAuthService {
  public static api = axios.create();
  public static readonly API_BASE_URL_SB = process.env.VUE_APP_API_BASE_URL_STAR_BRIDGE;
  public static readonly API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

  static async authenticate(sbToken?: string): Promise<{ contractId: string; serviceGroupId: string } | null> {
    const url = this.API_BASE_URL + `/auth/jwt`;
    const service = "execute-api";
    const lcToken = store.getters.lcToken;

    return await axios.post(url, { sbToken: sbToken, lcToken: lcToken, service: service }).then((response) => {
      if (response.status == 200) {
        const credentials = response.data as ICredentialsResponse;
        const contract = { contractId: credentials.contractId, serviceGroupId: credentials.serviceGroupId };
        store.commit("setState", {
          contract: Object.assign(store.getters.contract || {}, contract),
          lcToken: credentials.lcToken,
        });
        AuthService.clearCachedAuthCredentialsConfig(AuthService.currentTenantId());

        const newCredentials = {
          accessKeyId: credentials.AccessKeyId || "",
          secretAccessKey: credentials.SecretAccessKey || "",
          sessionToken: credentials.SessionToken,
          expireTime: credentials.Expiration,
          contractId: credentials.contractId,
          serviceGroupId: credentials.serviceGroupId,
          _version: process.env.VUE_APP_VERSION as string,
        };
        AuthService.setServiceCachedAuthCredentialsConfig(AuthService.currentTenantId(), service, newCredentials);
        AWS.config.update({
          credentials: AuthService.getCachedAuthCredentialsConfig(AuthService.currentTenantId())[service],
        });
        return contract;
      } else {
        return null;
      }
    });
  }
}
